(ns app.front.view.group.admin.fees.util.fee-utils
  (:require [app.i18n.model :as i18n-model]
            [potpuri.core :as p]))


(defn get-path
  "Returns the path ignoring unspecified steps."
  [permit-type category work-type work-target]
  (take-while some? [permit-type (when (not= category :fees/category-all) category) work-type work-target]))

(defn get-unsaved-for-target-path
  "Gets the unsaved structure for the given target path."
  [unsaved-changes target-path]
  (p/find-first unsaved-changes #(= target-path (:target-group-config-ids %))))

(defn strings-map [i18n-attrs entity]
  (->> i18n-attrs
       (reduce (fn [data [tr-attr attr]]
                 (assoc data tr-attr (i18n-model/strings-map (get data tr-attr)
                                                             (get data attr ""))))
               (into {} entity))))

(defn get-props-with-changes
  "Returns fields listed in `all-fields`, preferring a changed value
   if present in `changes`."
  [entity all-fields changes]
  (->> all-fields
       (map (fn [prop]
              [prop (if (contains? changes prop)
                      (get changes prop)
                      (get entity prop))]))
       (into {})))

(defn get-value-fn
  "Return a function that gets a given attribute from either the base entity or a changeset if present."
  [entity changes]
  (fn [attr]
    (let [original-value (get entity attr)
          modified-value (get changes attr)]
      ;; note, we need some?, not or, because there might be booleans
      (if (some? modified-value)
        modified-value
        original-value))))

(defn current-id-handler [[entity creating-new?] _]
  (if creating-new?
    :new
    (:db/id entity)))

(defn changes-handler [[unsaved-changes id] _]
  (get unsaved-changes id))
